import React, { useEffect, useState } from "react";
import LoadingScreen from "../screens/generic-screens/loading/LoadingScreen";
import LS_CONSTANTS from "../../constants/LSConstants";
import { useNavigate } from "react-router-dom";
const LOADING_DELAY_MS = 1000;

function RequireUnauth({ children }) {
  const [renderComponenet, setRenderComponenet] = useState(<LoadingScreen />);
  const navigate = useNavigate();
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const userData = JSON.parse(
        localStorage.getItem(LS_CONSTANTS.LS_USER_DATA)
      );
      const userSessionData = JSON.parse(
        localStorage.getItem(LS_CONSTANTS.LS_USER_SESSION_DATA)
      );
      if (
        !userData ||
        userData.access_token === undefined ||
        !userSessionData ||
        userSessionData.loggedInTime === undefined
      ) {
        setRenderComponenet(children);
      } else {
        navigate("/dashboard");
      }
    }, LOADING_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [navigate, children]);
  return renderComponenet;
}

export default RequireUnauth;
